module.exports = __webpack_public_path__ + "static/media/spinner.0b5e12da.svg";